import { JobId } from '@eigtech/restoration-types'
import { ensureJobCorn } from '@eigtech/restoration-util'
import {
  useGetAssignmentsForAssignable,
  useGetAssignmentsForAssignableSuspense,
} from '@eigtech/ui-shared-assignments'

export function useGetAssignmentsForJob(jobId: JobId) {
  return useGetAssignmentsForAssignable(ensureJobCorn(jobId))
}

export function useGetAssignmentsForJobSuspense(jobId: JobId) {
  return useGetAssignmentsForAssignableSuspense(ensureJobCorn(jobId))
}
